import React, { useReducer } from 'react';
import { reducer } from './reducer.esm.js';
import { ToastDispatchContext, ToastStateContext } from './ToastContext.esm.js';
import { Toasts } from './Toasts.esm.js';

function ToastProvider(_a) {
    var children = _a.children;
    var _b = useReducer(reducer, { toasts: [] }), state = _b[0], dispatch = _b[1];
    return (React.createElement(ToastDispatchContext.Provider, { value: {
            dispatch: dispatch
        } },
        React.createElement(ToastStateContext.Provider, { value: {
                state: state
            } },
            React.createElement(Toasts, null),
            children)));
}

export { ToastProvider };
//# sourceMappingURL=ToastProvider.esm.js.map
